module.exports = __webpack_public_path__ + "static/media/bank13.db262717.png";